import React, { useCallback, useEffect, useRef, useState } from 'react';
import moment from 'moment';

import styles from './countdownStyles.scss';

const Countdown: React.FC<{ date: string; inline?: boolean }> = ({ date, inline }) => {
  const targetDt = moment(new Date(date));
  const duration = useRef(moment.duration(targetDt.diff(moment())));
  const [seconds, setSeconds] = useState(duration.current.seconds());
  const [minutes, setMinutes] = useState(duration.current.minutes());
  const [hours, setHours] = useState(Math.floor(duration.current.asHours()));

  const countdownTimer = useCallback(() => {
    duration.current.add(1, 's');
    setSeconds(duration.current.seconds());
    setMinutes(duration.current.minutes());
    setHours(Math.floor(duration.current.asHours()));
  }, [duration]);

  const intervalId = useRef<NodeJS.Timeout | null>(null);
  const startTimer = useCallback(() => {
    intervalId.current = setInterval(countdownTimer, 1000);
  }, [countdownTimer]);

  useEffect(() => {
    if (intervalId.current) {
      window.clearInterval(intervalId.current);
    }
    duration.current = moment.duration(targetDt.diff(moment()));
    countdownTimer();
    startTimer();

    return (): void => {
      if (intervalId.current) {
        window.clearInterval(intervalId.current);
      }
    };
  }, [intervalId, startTimer, targetDt, countdownTimer]);

  if (inline)
    return (
      <span data-testid="countdown">
        <strong>{hours}</strong> hours : <strong>{minutes}</strong> minutes :{' '}
        <strong>{seconds}</strong> seconds
      </span>
    );

  return (
    <div data-testid="countdown">
      <div className={styles.countdownColumns}>
        <span>Hours</span>
        <span>Minutes</span>
        <span>Seconds</span>
      </div>
      <div className={styles.countdownColumns}>
        <span data-testid="hours">{hours}</span>
        <span data-testid="minutes">{minutes}</span>
        <span data-testid="seconds">{seconds}</span>
      </div>
    </div>
  );
};

export default Countdown;
